// @ts-nocheck
import { Dispatch, SetStateAction, useEffect, useMemo, useState, useRef } from "react";
import { Button, Table, message, Select, Space, Input } from "antd";
import fileDownload from "js-file-download";
import { ServiceTypes } from "../../../types/types";
import { Colors } from "../../../constants/Colors";
import type { ColumnsType } from "antd/es/table";
import { useReactiveVar } from "@apollo/client";
import { __currentUser__, __jwtToken__, __projectKey__, } from "../../../graphql/policies";
import { useGetUserAllGraduationApplyQuery } from "../../../graphql/operations/clubApp/graduation/get-user-all-graduation-apply";
import { useGetUserAllGraduationApplyTwQuery } from "../../../graphql/operations/clubApp/graduation/get-user-all-graduation-apply-tw";
import { useGetAllGraduationApplyQuery } from "../../../graphql/operations/clubApp/graduation/get-all-graduation-apply";
import { useGetAllGraduationTaskNameAndDescriptionQuery } from "../../../graphql/operations/clubApp/graduation/get-graduation-all-task";
import { useGetAllGraduationProcessQuery } from "../../../graphql/operations/clubApp/graduation/get-all-graduation-process";
import { useGetAllGraduationProcessTwQuery } from "../../../graphql/operations/clubApp/graduation/get-all-graduation-process-tw";
import "./GraduationReviewed.scss";
import dayjs from "dayjs";
import { useGetUserProgramsByServiceQuery } from "../../../graphql/operations/get-user-program-by-service";
import { apiCall } from "../../../utils/apiCall";
import { renderDecodedId } from "../../../utils/renderDecodedId";
import Spinner from "../../../components/layout/spinner/Spinner";
import NoPermission from "../../../components/others/NoPermission";
import { renderAntDMessageConfig } from "../../../utils/renderAntDMessageConfig";
import GraduationDrawer from "./GraduationDrawer";
import { DataType, TaskDataType, ProcessDataType } from "./types";
import {
  currentYearStart,
  currentYearEnd,
  currentYear,
  lastYearStart,
} from "./utils/yearPeriod";
import { isSpecialUser, specialUserMarket } from "./utils/specialUserMarket";
import { sortUserApplications } from "./utils/sortUserApplications";
import { countStatus } from "./utils/countStatus";
import {
  buildDateTreeFilters,
  matchesDateTreeFilter,
} from "./utils/buildDateTreeFilters";

interface GraduationReviewedProps {
  setSelectedService: Dispatch<SetStateAction<ServiceTypes>>;
  setSelectSubItem: Dispatch<SetStateAction<string | undefined>>;
}

const GraduationReviewed = ({
  setSelectedService,
  setSelectSubItem,
}: GraduationReviewedProps) => {
  const jwtToken = useReactiveVar(__jwtToken__);
  const projectKey = useReactiveVar(__projectKey__);
  const [displayData, setDisplayData] = useState<DataType[] | any>([]);
  const [temp, setTemp] = useState<DataType[] | any>([]);
  const [taskDataList, setTaskDataList] = useState<TaskDataType[] | any>([]);
  const [currentMarket, setCurrentMarket] = useState("");
  const [showDrawer, setShowDrawer] = useState(false);
  const [total, setTotal] = useState(0);
  const [selectedGraduationData, setSelectedGraduationData] = useState<
    DataType | any
  >();
  const [selectedGraduationAudio, setSelectedGraduationAudio] = useState();
  const [taskProgress, setTaskProgress] = useState([0, 0]);
  const [taskProgressArray, setTaskProgressArray] = useState<number[]>([]);
  const [isExcellent, setIsExcellent] = useState(false);
  const [allProcessData, setAllProcessData] = useState<ProcessDataType[]>([]);
  const [userAllApplications, setUserAllApplications] = useState<
    DataType[] | any
  >([]);
  const [filteredAllApplications, setFilteredAllApplications] = useState<
    DataType[] | any
  >([]);
  const { Search } = Input;
  const handleSearchMemberNo = (memberNo: string) => {
    memberNo = memberNo.trim();
    if (!memberNo && temp.length > 0) {
      setDisplayData(temp);
    }
    if (temp.length === 0) {
      setTemp(displayData);
      const replica = [...displayData];
      setDisplayData(
        replica.filter((item) => item.memberNo.includes(memberNo))
      );
    } else {
      const replica = [...temp];
      setDisplayData(
        replica.filter((item) => item.memberNo.includes(memberNo))
      );
    }
  };

  const currentUser = useReactiveVar(__currentUser__);
  const {
    data: userPrograms,
    loading: userProgramsLoading,
    error: userProgramsError,
  } = useGetUserProgramsByServiceQuery({
    variables: {
      userId: parseInt(renderDecodedId(currentUser?.id)),
      serviceId: 2,
    },
  });

  const dateFilter = useMemo(
    () =>
      buildDateTreeFilters(displayData.map((data) => data.applicationDate)),
    [displayData]
  );

  const columns: ColumnsType<DataType> = [
    {
      title: "Last applied",
      dataIndex: "applicationDate",
      key: "applicationDate",
      width: 200,
      render: (value: string) =>
        value ? dayjs(value).format("YYYY-MM-DD") : "",
      filters: dateFilter,
      filterMode: "tree",
      onFilter: (value, record) => {
        if (!record.applicationDate) {
          return false;
        }

        return matchesDateTreeFilter(
          record.applicationDate,
          String(value)
        );
      },
    },
    {
      title: "Last evaluated",
      dataIndex: "lastEvaluatedDate",
      key: "lastEvaluatedDate",
      render: (value: string) =>
        value ? dayjs(value).format("YYYY-MM-DD") : "",
      width: 200,
    },
    {
      title: "Member ID",
      dataIndex: "memberNo",
      key: "memberNo",
      width: 150,
    },
    {
      title: "Kid (age)",
      dataIndex: "childName",
      key: "kidAge",
      width: 150,
      render: (text, record) => {
        const years = record.age.substring(0, record.age.indexOf("Y"));
        return (
          <span>
            {text} ({years})
          </span>
        );
      },
    },
    {
      title: "English name",
      dataIndex: "childEnglishName",
      key: "childEnglishName",
      width: 150,
    },
    {
      title: "Progress",
      key: "progress",
      width: 220,
      render: (_, record) => {
        const kidAll = allProcessData.filter(
          (data) =>
            data.memberNo === record.memberNo && data.childNo === record.childNo
        );
        const kid = kidAll.reduce((acc, obj) => {
          acc.approvedCount = (acc.approvedCount || 0) + obj.approvedCount;
          acc.rejectedCount = (acc.rejectedCount || 0) + obj.rejectedCount;
          acc.applicationCount =
            (acc.applicationCount || 0) + obj.applicationCount;
          return acc;
        }, {});
        const passCount = kid?.approvedCount;
        const failedCount = kid?.rejectedCount;
        const total = kid?.applicationCount;
        const inReviewCount =
          currentMarket === "TW"
            ? kid?.inReviewCount
            : total - passCount - failedCount;
        const progressArray = [];
        for (let i = 0; i < passCount; i++) {
          progressArray.push(0);
        }
        for (let i = 0; i < inReviewCount; i++) {
          progressArray.push(1);
        }
        while (progressArray.length < 8) {
          progressArray.push(2);
        }

        return (
          <div className="progress-bar-container">
            <div className="progress-bar">
              {progressArray.map((item) => (
                <div
                  className="unit"
                  style={
                    item === 0
                      ? { backgroundColor: "#071491" }
                      : item === 1
                        ? { backgroundColor: "#C7CDFC" }
                        : { backgroundColor: "#F5F5F5" }
                  }
                ></div>
              ))}
              <p className="text-vertical-center content">{passCount}/8</p>
            </div>
          </div>
        );
      },
    },
    {
      title: "Excellent",
      key: "excellent",
      width: 120,
      filters: [
        { text: "Yes", value: true },
        { text: "No", value: false },
      ],
      onFilter: (value, record) => {
        const kid = allProcessData.find(
          (data) =>
            data.memberNo === record.memberNo && data.childNo === record.childNo
        );
        return kid.isExcellent === value;
      },
      render: (_, record) => {
        const kid = allProcessData.find(
          (data) =>
            data.memberNo === record.memberNo && data.childNo === record.childNo
        );
        return (
          <div>
            {kid?.isExcellent ? (
              <div className="excellent-container">
                <div>Yes</div>
                <img
                  alt="trophy icon"
                  className="trophy-icon"
                  src={require("../../../assets/icons/clubApp/graduation/trophy.png")}
                ></img>
              </div>
            ) : null}
          </div>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      width: 100,
      render: (_, record) => (
        <Button
          type="link"
          onClick={() => {
            const kid = allProcessData.find(
              (data) =>
                data.memberNo === record.memberNo &&
                data.childNo === record.childNo
            );
            setIsExcellent(kid?.isExcellent);
            setSelectedGraduationData(record);
            setShowDrawer(true);
          }}
        >
          View
        </Button>
      ),
    },
  ];
  const { data, loading, refetch } = useGetAllGraduationApplyQuery({
    variables: {
      currentYearStart: lastYearStart,
      currentYearEnd: currentYearEnd,
    },
  });

  const { data: processData, refetch: processRefetch } =
    useGetAllGraduationProcessQuery({
      variables: {
        market: currentMarket,
      },
    });
  const { data: userData, refetch: userDataRefetch } =
    useGetUserAllGraduationApplyQuery({
      variables: {
        memberNo: selectedGraduationData?.memberNo,
        childNo: selectedGraduationData?.childNo,
      },
    });
  const { data: taskData } = useGetAllGraduationTaskNameAndDescriptionQuery();
  const handleChange = (value: string) => {
    setCurrentMarket(value);
  };

  const fetchStorytellingFile = async () => {
    try {
      const result = await apiCall({
        method: "GET",
        header: {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "X-Project-Id": "AF",
            "X-Authorization-Provider": "Anonymous",
            "X-Project-Key": projectKey,
          }
        },
        endPoint:
          process.env.REACT_APP_ADMIN_API +
          "graduation/GetStorytellingFile" +
          `/${selectedGraduationData.market}` +
          `/${selectedGraduationData.memberNo}` +
          `/${selectedGraduationData.childNo}`
      });

      setSelectedGraduationAudio(result);
    } catch (error) {
    }
  };

  const handleStorytellingFilesClick = async () => {
    try {
      const result = await apiCall({
        method: "GET",
        header: {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "X-Project-Id": "AF",
            "X-Authorization-Provider": "Anonymous",
            "X-Project-Key": projectKey,
          },
          responseType: "blob",
        },
        endPoint:
          process.env.REACT_APP_ADMIN_API +
          "graduation/GetStorytellingFiles" +
          `/${currentMarket}`
      });

      if (result.size === 0)
        message.error(renderAntDMessageConfig("No data found"));
      else
        fileDownload(result, "StorytellingFiles.zip");
    } catch (error) {

    }
  };

  useEffect(() => {
    setSelectedService(ServiceTypes.CLUB_APP);
    setSelectSubItem("All Applications");
  }, [setSelectedService, setSelectSubItem]);
  useEffect(() => {
    refetch();
    processRefetch();
    userDataRefetch();
  }, [selectedGraduationData]);
  useEffect(() => {
    setAllProcessData(processData?.afChildGraduationApplication || []);
  }, [processData]);
  useEffect(() => {
    if (userData) {
      setUserAllApplications(
        userData.club_worldFamilyClub_graduationApplication?.nodes
      );
    }
  }, [userData, currentMarket]);
  useEffect(() => {
    const { passCount, underReviewCount } = countStatus(
      [...userAllApplications],
      0,
      0
    );
    setTaskProgress([passCount, underReviewCount]);
    const sorted = sortUserApplications([...userAllApplications]);
    setFilteredAllApplications(sorted);
  }, [userAllApplications]);
  useEffect(() => {
    const replica = [];
    for (let i = 1; i < 9; i++) {
      if (i <= taskProgress[0]) {
        replica.push(0);
      } else if (i <= taskProgress[0] + taskProgress[1]) {
        replica.push(1);
      } else {
        replica.push(2);
      }
    }
    setTaskProgressArray(replica);
  }, [taskProgress]);
  useEffect(() => {
    if (data) {
      const temporalData = data.afGraduationApplication.filter((data) => {
        return data.market === currentMarket;
      });
      const filteredData = temporalData.reduce((result, current) => {
        const key = `${current.memberNo}_${current.childNo}`;
        if (!result[key]) {
          result[key] = [];
        }
        result[key].push(current);
        return result;
      }, {});
      const finalResult = Object.values(filteredData).map((group) => {
        group.sort(
          (a, b) => new Date(b.applicationDate) - new Date(a.applicationDate)
        );
        return group[0];
      });
      const lastEvaluatedDate = Object.values(filteredData).map((group) => {
        group.sort(
          (a, b) => new Date(b.approvalDate) - new Date(a.approvalDate)
        );
        return group[0];
      });
      if (finalResult && lastEvaluatedDate) {
        const resultWithLastEvaluatedDate = finalResult.map((kid) => {
          const recordOfLastEvaluatedDate = lastEvaluatedDate?.find(
            (item) =>
              item?.memberNo === kid?.memberNo && item?.childNo === kid?.childNo
          );
          return {
            ...kid,
            lastEvaluatedDate: recordOfLastEvaluatedDate?.approvalDate,
          };
        });
        setDisplayData(resultWithLastEvaluatedDate);
        setTemp(resultWithLastEvaluatedDate);
      }
    }
  }, [currentMarket, taskDataList, data]);

  useEffect(() => {
    setTotal(displayData.length);
  }, [displayData]);
  useEffect(() => {
    if (taskData) {
      setTaskDataList(
        taskData.club_worldFamilyClub_graduationTaskMarketDescription?.nodes
      );
    }
  }, [taskData]);
  useEffect(() => {
    if (currentUser?.afUserMarkets && currentUser?.afUserMarkets[0]?.market) {
      if (currentUser?.afUserMarkets.length === 1) {
        setCurrentMarket(currentUser?.afUserMarkets[0]?.market);
      } else {
        setCurrentMarket("TW");
      }
    }
  }, [currentUser]);

  useEffect(() => {
    if (showDrawer && currentMarket === "KR")
      fetchStorytellingFile();
  }, [showDrawer]);

  if (userProgramsError) {
    message.error(
      renderAntDMessageConfig(
        "Something went wrong. Please contact your system administrator."
      )
    );
  }

  if (userProgramsLoading) {
    return <Spinner />;
  }
  if (loading) {
    return <Spinner />;
  }

  if (
    userPrograms &&
    !userPrograms.wf_adminFirst_afUserProgram?.edges?.find(
      (item) => item.node.afProgram?.programName === "Graduation Reviewed"
    )
  ) {
    return <NoPermission />;
  }

  return (
    <div id="graduationReviewedWrapper">
      <div className="header" style={{ backgroundColor: Colors.white }}>
        <p className="header-title" style={{ color: Colors.darkGrey }}>
          All Applications
        </p>
      </div>
      <div className="table-container">
        <div className="select">
          <div className="total-container">{`Total ${total} items`}</div>
          <div className="flex">
            <div
              style={
                currentUser?.afUserMarkets?.length === 1 &&
                  !isSpecialUser(currentUser?.userEmail)
                  ? { display: "none" }
                  : {}
              }
            >
              <span>Market:</span>
              <Select
                onChange={handleChange}
                defaultValue="TW"
                options={specialUserMarket(currentUser?.userEmail)}
              ></Select>
            </div>
            <div>
              <Search
                placeholder="Search member ID"
                width={285}
                allowClear
                onSearch={handleSearchMemberNo}
              />
            </div>
            {currentMarket === "KR" && (
              <div style={{ marginLeft: "15px" }}>
                <Button type="primary" onClick={handleStorytellingFilesClick}>
                  Download Storytelling files
                </Button>
              </div>
            )}
          </div>
        </div>
        <Table
          className="table"
          columns={columns}
          dataSource={displayData}
          onChange={(pagination, filters, sorter, extra) => {
            setTotal(extra.currentDataSource.length);
          }}
          scroll={{
            x: true,
            y: 500,
          }}
          pagination={{
            pageSize: 10,
            showSizeChanger: false,
          }}
        />
      </div>
      <GraduationDrawer
        showDrawer={showDrawer}
        setShowDrawer={setShowDrawer}
        selectedGraduationData={selectedGraduationData}
        selectedGraduationAudio={selectedGraduationAudio}
        taskProgress={taskProgress}
        taskProgressArray={taskProgressArray}
        taskDataList={taskDataList}
        isExcellent={isExcellent}
        setIsExcellent={null}
        isExcellentEnabled={false}
        filteredAllApplications={filteredAllApplications}
      />
    </div>
  );
};

export default GraduationReviewed;
